/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * 
 * @format
 * @emails oncall+internationalization
 */
'use strict';

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var FBLogger = require("./FBLogger");

var FbtResultBase = require("./FbtResultBase");

var killswitch = require("./killswitch");

function logErrorUseStringMethod(methodName) {
  // If the contents is array of length greater than one, then use the string
  // method will cause error
  FBLogger('fbt').blameToPreviousFile().mustfix('Error using fbt string. Used method %s' + ' on Fbt string. Fbt string is designed to be immutable ' + 'and should not be manipulated.', methodName);
}
/**
 * The FbtResultBase "implemented" module for www.
 */


var FbtResultWWW =
/*#__PURE__*/
function (_FbtResultBase) {
  _inheritsLoose(FbtResultWWW, _FbtResultBase);

  function FbtResultWWW() {
    return _FbtResultBase.apply(this, arguments) || this;
  }

  var _proto = FbtResultWWW.prototype;

  _proto.onStringSerializationError = function onStringSerializationError(content) {
    var details = 'Context not logged.';

    if (!killswitch('JS_RELIABILITY_FBT_LOGGING')) {
      try {
        details = JSON.stringify(content).substr(0, 250);
      } catch (err) {
        // Catching circular reference error
        details = err.message;
      }
    }

    FBLogger('fbt').blameToPreviousFile().mustfix('Converting to a string will drop content data. %s', details);
  };

  return FbtResultWWW;
}(FbtResultBase);

var FbtResultWWWWithStringishMethods = FbtResultWWW.usingStringProxyMethod(function (methodName) {
  return function () {
    logErrorUseStringMethod(methodName); // $FlowFixMe Mock stringish methods

    return String.prototype[methodName].apply(this, arguments);
  };
});
module.exports = FbtResultWWWWithStringishMethods;